import React from 'react';
import EditableEntity from '../EditableText';
import { QuestionTextEditorProps } from '../types/questionTypes';

const QuestionTextEditor: React.FC<QuestionTextEditorProps> = ({
  edit,
  textValue,
  placeholder,
  onTextChange,
  parsedContent = [],
  onEntityUpdate,
}) => {
  if (edit) {
    return (
      <div className="relative w-full border rounded-md p-2 bg-white overflow-hidden">
        <textarea
          className="w-full min-h-[200px] border-none outline-none bg-transparent resize-none caret-black text-black whitespace-pre-wrap font-sans text-sm font-normal leading-[22px]"
          placeholder={placeholder}
          value={textValue}
          onChange={(e) => onTextChange(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          onInput={(e) => {
            const target = e.target as HTMLTextAreaElement;
            target.style.height = "auto";
            target.style.height = `${target.scrollHeight}px`;
          }}
          spellCheck={false}
          style={{
            width: "100%",
            height: "auto",
            overflow: "hidden",
            background: "transparent",
            position: "relative",
            zIndex: 2,
          }}
          autoFocus
        />
      </div>
    );
  }

  return (
    <div
      className="mb-4 p-4 bg-white rounded-lg shadow text-sm font-normal text-black"
      style={{
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        fontFamily: "inherit",
        lineHeight: "2",
      }}
    >
      {parsedContent.map((segment, index) => {
        if (segment.type === "entity") {
          return (
            <span key={index} onClick={(e) => e.stopPropagation()}>
              <EditableEntity
                value={segment.content}
                onUpdate={(newValue) =>
                  onEntityUpdate?.(segment.entityIndex, newValue)
                }
              />
            </span>
          );
        }
        return (
          <span key={index}>{segment.content.replace(/`/g, "")}</span>
        );
      })}
    </div>
  );
};

export default QuestionTextEditor;
